import { useEffect, useState } from 'react'

const STORAGE_PREFIX = 'bhmm.advertisingLastSeen'

export default function useAdvertisingTrigger(advertising) {
  const [shouldShow, setShouldShow] = useState(false)
  const [activeAd, setActiveAd] = useState(null)

  useEffect(() => {
    if (!advertising) return
    if (!advertising.isActive) return

    const today = new Date().toISOString().split('T')[0]
    const storageKey = `${STORAGE_PREFIX}_${advertising.id}`

    if (localStorage.getItem(storageKey) === today) return

    const timer = setTimeout(() => {
      setActiveAd(advertising)
      setShouldShow(true)
    }, advertising.delay || 1200)

    return () => clearTimeout(timer)
  }, [advertising])

  const markAsSeen = () => {
    if (!activeAd) return
    const today = new Date().toISOString().split('T')[0]
    localStorage.setItem(
      `${STORAGE_PREFIX}_${activeAd.id}`,
      today
    )
    setShouldShow(false)
  }

  return {
    shouldShow,
    markAsSeen,
    activeAd
  }
}
